import { POST } from '../apiController';

const PUBLIC_DELETION_BASE = '/org/public/account-deletion';
const PUBLIC_REQUEST_OPTIONS = { skipAuth: true };

export function publicLookupDeletionEmail(data) {
  return POST(`${PUBLIC_DELETION_BASE}/lookup-email`, data, PUBLIC_REQUEST_OPTIONS);
}

export function publicSendDeletionOtp(data) {
  return POST(`${PUBLIC_DELETION_BASE}/send-otp`, data, PUBLIC_REQUEST_OPTIONS);
}

export function publicVerifyDeletionOtp(data) {
  return POST(`${PUBLIC_DELETION_BASE}/verify-otp`, data, PUBLIC_REQUEST_OPTIONS);
}

export function publicDeleteAccount(data) {
  return POST(`${PUBLIC_DELETION_BASE}/delete`, data, PUBLIC_REQUEST_OPTIONS);
}
